import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import NavigationClose from "@material-ui/icons/Close";

import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';

import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { pushRightPanel } from "../actions/dashboard";
import ContentRightpanel from "../granular/Portal/rightpanel";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import classNames from "classnames";

const styles = {
  paper: {
    root: {
      background: "black"
    }
  }
};

class Rightpanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      right: this.props.rightPanel
    };
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ right: nextProps.rightPanel });
  }

  handleRighpanelClose = () => {
    this.props.pushRightPanel(!this.state.right);
  }

  render() {
    return (
      <Drawer
        anchor="right"
        variant="persistent"
        open={this.state.right}
        classes={{
          paper: { backgroundColor: "red" }
        }}
      >
        <AppBar position="static" style={{ background: '#4083FF' }}>
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Menu"
              onClick={this.handleRighpanelClose}
            >
              <MenuIcon />
            </IconButton>

          </Toolbar>
        </AppBar>
        <div style={{ width:"300px" }}>
          <ContentRightpanel />
        </div>
      </Drawer>
    );
  }
}

Rightpanel.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel
  };
}

export default withRouter(connect(mapStateToProps, {pushRightPanel})(Rightpanel));
